
import { computed, defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'BCardModal',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit, slots }) {
    const isModalActive = ref(props.isActive)

    const hasSlotHeader = computed(() => slots.title)

    const hasSlotFooter = computed(() => slots.footer)

    watch(() => props.isActive, newValue => isModalActive.value = newValue)

    function close() {
      isModalActive.value = false
      emit('close', false)
    }
    return {
      close,
      isModalActive,
      hasSlotHeader,
      hasSlotFooter,
    }
  },
})
